const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnelLvl4Disable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 344.23 91.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.5,77.68s-30.38,10.64-63.38,10.64c-32,0-62-10.64-62-10.64l-18.5-63s40.5,11.14,80.59,11.14c38.72,0,80.44-11,80.44-11Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172,3.27c-48.14,0-80.4,11.4-80.4,11.4A311.39,311.39,0,0,0,172.35,26c41.42,0,80.28-11.14,80.28-11.14A294,294,0,0,0,172,3.27Z",
    style: {
      fill: "#8da343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5,77.68s-30.38,10.64-63.38,10.64c-32,0-62-10.64-62-10.64l-18.5-63s40.5,11.14,80.59,11.14c38.72,0,80.44-11,80.44-11Z",
    style: {
      fill: "#adc868"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "135.24 85.99 117.36 84.39 100.79 15.01 124.33 17.5 135.24 85.99",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.64 85.99 240.38 80.06 258.67 12.57 223.56 17.5 212.64 85.99",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelLvl4Disable);
export default __webpack_public_path__ + "static/media/funnel-lvl4-disable.505391862d9f1a1f09a49bf79a1dd178.svg";
export { ForwardRef as ReactComponent };